import { DesignFutureWrapper } from "../../styles/StyledComponents/DesignFutureWrapper";
import CommonButton from "../../ui/CommonButton/CommonButton";
import assests from "../../ui/assests";

const DesignFutureSec = () => {
  return (
    <DesignFutureWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="design_future_card">
          <figure>
            <img src={assests.DesignFutureSecBg} alt="DesignFutureSecBg" />
          </figure>
          <div className="design_heading">
            <h2>DESIGN THE FUTURE WITH EMIIT</h2>
            <CommonButton variant="contained" color="primary">
              View All Works
            </CommonButton>
          </div>
        </div>
      </div>
    </DesignFutureWrapper>
  );
};

export default DesignFutureSec;
